import { useTheme } from "styled-components";

import logo from "@sso/assets/basemap-logo.png";
import { useMediaQuery } from "@sso/hooks/useMediaQuery";
import { useAppSelector } from "@sso/hooks/useRedux";
import { selectCurrentUser } from "@sso/store/slices/auth";
import { RowContainer } from "@sso/ui/FlexBox";
import { Img } from "@sso/ui/Img";
import { Typography } from "@sso/ui/Typography";

import { drawerItems } from "./drawerItems";
import { NavGroup } from "./NavGroup";

export const DrawerList = () => {
  const theme = useTheme();
  const user = useAppSelector(selectCurrentUser);

  const isMatchedDownSm = useMediaQuery(`(max-width: ${theme.breakpoints.sm})`);

  return (
    <>
      {isMatchedDownSm && (
        <>
          <RowContainer width="100%">
            <Img src={logo} alt="basemap logo" width="auto" height="40px" margin="0 0.75rem" />
            <Typography size="1.5rem" fontWeight="bold" color={theme.colors.primary.dark}>
              SSO
            </Typography>
          </RowContainer>
          <Typography
            as="h2"
            overflowEllipsis
            width="100%"
            size="1.1rem"
            fontWeight="bold"
            padding="1rem 0.5rem"
            textTransform="capitalize"
          >
            {user?.organisation?.name || "NA"}
          </Typography>
        </>
      )}
      {drawerItems.map(item => (
        <NavGroup key={item.id} navGroupItem={item} />
      ))}
    </>
  );
};
